
import React from 'react'
import Menu from './Menu'
export default function MenuList({ menu }) {
    if (menu.length === 0) {
        return (
            <div className="empty-search">
                <h3>unfortunately, your selected options not matched with any.</h3>
            </div>
        );
    }
    return (

        <section className="menuList">
            <div className="menulist-center">
                {
                    menu.map(item => {
                        return <Menu key={item.id} menu={item} />;
                    })
                }
            </div>
        </section>
    )
}
